/* Related Products carousel — adapated from category-carousel.js.
   Breakpoints: ≥1024px → 4 visible, 768–1023px → 3, <768px → 2. */

(function () {
  var section = document.querySelector('.tov-related-products[data-section-id]');
  if (!section) return;

  var sectionId = section.dataset.sectionId;
  var productId = section.dataset.productId;
  var limit     = parseInt(section.dataset.limit, 10) || 8;
  var track     = document.getElementById('rp-track-' + sectionId);
  var prevBtn   = document.getElementById('rp-prev-' + sectionId);
  var nextBtn   = document.getElementById('rp-next-' + sectionId);
  var inner     = document.getElementById('rp-inner-' + sectionId);

  if (!track || !inner) return;

  var GAP          = 24;
  var currentIndex = 0;
  var cardWidth    = 0;

  function getVisible() {
    if (window.innerWidth >= 1024) return 4;
    if (window.innerWidth >= 768)  return 3;
    return 2;
  }

  function recalculate() {
    var viewport  = track.parentElement;
    var visible   = getVisible();
    var totalGaps = (visible - 1) * GAP;
    var vw        = viewport.offsetWidth;
    cardWidth = (vw - totalGaps) / visible;
    var cards = track.querySelectorAll('.carousel-card');
    cards.forEach(function (card) { card.style.width = cardWidth + 'px'; });
  }

  function slide() {
    var cards    = track.querySelectorAll('.carousel-card');
    var visible  = getVisible();
    var maxIndex = Math.max(0, cards.length - visible);
    currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));
    track.style.transform = 'translateX(-' + (currentIndex * (cardWidth + GAP)) + 'px)';
    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { currentIndex--; slide(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { currentIndex++; slide(); });

  /* Touch swipe */
  var startX = 0;
  track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', function (e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      currentIndex += diff > 0 ? 1 : -1;
      slide();
    }
  });

  /* Debounced resize */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      currentIndex = 0;
      recalculate();
      slide();
    }, 150);
  });

  /* Fetch recommendations, inject cards, then initialise */
  var url = '/recommendations/products.json?product_id=' + productId
          + '&limit=' + limit + '&intent=related';

  fetch(url)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = data.products;
      if (!products || !products.length) {
        /* No recommendations — hide the whole section */
        section.style.display = 'none';
        return;
      }

      /* Build card HTML from returned product data — mirrors snippets/tov-product-card.liquid
         so variant selection, add-to-cart and sold-out states match the rest of the grid.
         product-card.js already delegates click/change handlers from document, so these
         dynamically injected cards wire up automatically once the markup/data attrs match. */
      function escHtml(str) {
        return String(str == null ? '' : str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }
      function moneyFmt(cents) {
        return 'Rs\u00A0' + Math.round(cents / 100).toLocaleString('en-PK');
      }

      var html = products.map(function (p) {
        var variants   = p.variants || [];
        var isVariable = variants.length > 1;
        var isSoldout  = p.available === false;
        var isOrganic  = (p.tags || []).indexOf('organic') > -1;

        var firstVariant = variants[0] || {};

        var hasDiscount  = false;
        var discountPct  = 0;
        if (p.price_varies) {
          var maxPct = 0;
          variants.forEach(function (v) {
            if (v.compare_at_price > v.price) {
              var pct = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
              if (pct > maxPct) maxPct = pct;
            }
          });
          if (maxPct > 0) { hasDiscount = true; discountPct = maxPct; }
        } else if (p.compare_at_price > p.price) {
          hasDiscount = true;
          discountPct = Math.floor((p.compare_at_price - p.price) * 100 / p.compare_at_price);
        }

        /* Append width param so Shopify CDN serves a correctly-sized image instead of full-res. */
        var imgSrc = p.featured_image
          ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600'
          : '';
        var img = imgSrc
          ? '<img src="' + imgSrc + '" alt="' + escHtml(p.title) + '" loading="lazy">'
          : '';

        var badgesHtml = '';
        if (isOrganic || hasDiscount) {
          badgesHtml = '<div class="card-badges">'
            + (isOrganic ? '<span class="badge-organic">Organic</span>' : '')
            + (hasDiscount ? '<span class="badge-discount">-' + discountPct + '%</span>' : '')
            + '</div>';
        }

        var overlayHtml = '';
        if (isVariable) {
          var optionsHtml = variants.map(function (v) {
            return '<option value="' + v.id + '" data-price="' + moneyFmt(v.price) + '"' + (v.available ? '' : ' disabled') + '>' + escHtml(v.title) + '</option>';
          }).join('');
          overlayHtml = '<div class="variation-overlay" id="var-overlay-' + p.id + '">'
            + '<div class="overlay-close-row">'
            + '<button class="overlay-close-btn" data-close-overlay="' + p.id + '">'
            + '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" class="icon"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg> Close'
            + '</button>'
            + '</div>'
            + '<div class="overlay-body">'
            + '<p class="label">' + escHtml(p.options && p.options[0]) + ':</p>'
            + '<div class="select-wrap">'
            + '<select class="overlay-variant-select" data-product-id="' + p.id + '">' + optionsHtml + '</select>'
            + '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" class="icon"><path d="m6 9 6 6 6-6"/></svg>'
            + '</div>'
            + '<button class="overlay-clear-btn" data-clear-overlay="' + p.id + '">'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" class="icon"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg> Clear'
            + '</button>'
            + '<span class="overlay-price" id="overlay-price-' + p.id + '">' + moneyFmt(firstVariant.price) + '</span>'
            + '</div>'
            + '<button class="overlay-add-btn" data-overlay-add="' + p.id + '" data-variant-id="' + firstVariant.id + '">Add to Cart</button>'
            + '</div>';
        }

        var priceHtml;
        if (p.price_varies) {
          priceHtml = '<span class="card-price">' + moneyFmt(p.price_min) + ' – ' + moneyFmt(p.price_max) + '</span>';
        } else {
          priceHtml = '<span class="card-price">' + moneyFmt(p.price) + '</span>'
            + (hasDiscount ? '<span class="card-price-original">' + moneyFmt(p.compare_at_price) + '</span>' : '');
        }

        var ctaHtml;
        if (isSoldout) {
          ctaHtml = '<button class="card-cta out-of-stock" disabled>Out of Stock</button>';
        } else if (isVariable) {
          ctaHtml = '<button class="card-cta select-options" data-open-overlay="' + p.id + '">Select Options</button>';
        } else {
          ctaHtml = '<button class="card-cta in-stock" data-add-to-cart="' + firstVariant.id + '">Add to Cart</button>';
        }

        return '<div class="carousel-card">'
          + '<div class="product-card' + (isSoldout ? ' soldout' : '') + '" data-product-id="' + p.id + '">'
          + '<div class="card-img-wrap">'
          + '<a href="' + p.url + '" aria-label="' + escHtml(p.title) + '" tabindex="-1">' + img + '</a>'
          + badgesHtml
          + overlayHtml
          + '</div>'
          + '<div class="card-body">'
          + '<a href="' + p.url + '" style="text-decoration:none;color:inherit;"><div class="card-name">' + escHtml(p.title) + '</div></a>'
          + '<div class="card-category">' + escHtml(p.type) + '</div>'
          + '<div class="card-price-row">' + priceHtml + '</div>'
          + '</div>'
          + ctaHtml
          + '</div></div>';
      }).join('');

      track.innerHTML = html;
      inner.style.display = '';   /* reveal the carousel */

      window.addEventListener('load', function () { recalculate(); slide(); });
      recalculate();
      slide();
    })
    .catch(function () {
      section.style.display = 'none';
    });
})();
